import pluginDataMigrations from './pluginData';
import layoutItemMigrations from './layoutItem';
import { mapValues } from 'lodash';

/**
* Migrations for the overall "website" object of the event site editor.
*/
export default function websiteMigrations(website) {
  return {
    ...website,
    eventVersion: 1,
    layoutItems: mapValues(website.layoutItems, layoutItemMigrations),
    pluginData: pluginDataMigrations(website.pluginData)
  };
}
